// =============== START OF PRODUCT CALCULATOR ===============
document.addEventListener("DOMContentLoaded", function () {

  if (!document.getElementById("variant-json-data")) return;

  const productType = window.productCalculatorType;

  const variantData = JSON.parse(
    document.getElementById("variant-json-data").textContent
  ).variants;

  const surfaceInput  = document.querySelector("#input-surface");
  const heightInput   = document.querySelector("#fence-height");
  const lengthInput   = document.querySelector("#linear-meters");

  const qtyDisplay    = document.querySelector("#calculated-qty");
  const priceDisplay  = document.querySelector("#calculated-price");

  const nativeQtyInput = document.querySelector('input[name="quantity"]');

  let currentVariant = null;

  function setVariant(variantId) {

    currentVariant = variantData.find(v => v.id == variantId);

    recalc();

  }

  function getWasteFactor(area){

    if (area < 10) return 1.15;
    if (area >= 10 && area <= 20) return 1.10;
    if (area > 20 && area <= 40) return 1.07;

    return 1.05;
  }

  function recalc(){

  if (!currentVariant) return;

  let qty = 1; // default safe value
  let isValid = false;

  const price = currentVariant.var_price;

  /* ================= TERRASSE ================= */

  // if(productType === "Terrasse" && surfaceInput){

  //   const surface = parseFloat(surfaceInput.value);
  //   const boardArea = parseFloat(currentVariant.board_surface_area);

  //   if(surface && surface > 0 && boardArea > 0){

  //     const boardsPerSqm = Math.floor((1 / boardArea) * 100) / 100;
  //     const wasteFactor = getWasteFactor(surface);

  //     qty = Math.ceil(surface * boardsPerSqm * wasteFactor);
  //     isValid = true;

  //   } else {

  //     qtyDisplay.value = "0 lames";
  //     if(priceDisplay) priceDisplay.textContent = formatMoney(0);

  //   }

  // }

    if(productType === "Terrasse" && surfaceInput){

        const surface = parseFloat(surfaceInput.value);
        const boardArea = parseFloat(currentVariant.board_surface_area);

        if(surface && surface > 0 && boardArea > 0){

          // NEW FORMULA (NO WASTE FACTOR)
          qty = Math.ceil(surface / boardArea);

          isValid = true;

        } else {

          qtyDisplay.value = "0 lames";
          if(priceDisplay) priceDisplay.textContent = formatMoney(0);

        }

    }

  /* ================= CLOTURE ================= */

  else if(productType === "Clôture" && heightInput && lengthInput){

    const fenceHeight = parseFloat(heightInput.value);
    const linearMeters = parseFloat(lengthInput.value);

    const boardHeight = parseFloat(currentVariant.board_height);
    const boardLength = parseFloat(currentVariant.board_length);

    if(
      fenceHeight && fenceHeight > 0 &&
      linearMeters && linearMeters > 0
    ){

      const boardsInHeight = Math.ceil(fenceHeight / boardHeight);
      const boardsInLength = Math.ceil(linearMeters / boardLength);

      qty = boardsInHeight * boardsInLength;
      isValid = true;

    } else {

      qtyDisplay.value = "0 lames";
      if(priceDisplay) priceDisplay.textContent = formatMoney(0);

    }

  }

  /* ================= OUTPUT ================= */

  if(isValid){

    const unitLabel = productType === "Terrasse" ? "lames" : "lames";

    qtyDisplay.value = qty + " " + unitLabel;

    const totalPrice = qty * price;

    if(priceDisplay){
      priceDisplay.textContent = formatMoney(totalPrice);
    }

  }

  // ALWAYS enforce minimum qty = 1
  nativeQtyInput.value = Math.max(1, qty);
  nativeQtyInput.dispatchEvent(new Event("change",{bubbles:true}));

  }

  if(surfaceInput) surfaceInput.addEventListener("input", recalc);
  if(heightInput) heightInput.addEventListener("input", recalc);
  if(lengthInput) lengthInput.addEventListener("input", recalc);

  document.addEventListener("variant:change", function(event){

    const variant = event.detail.variant;

    if(!variant) return;

    setVariant(variant.id);

  });

  const initialVariantField = document.querySelector('[name="id"]');

  if(initialVariantField){

    setVariant(initialVariantField.value);

  }

});
// =============== END OF PRODUCT CALCULATOR =================


// =============== PRODUCT TOOLTIP =========================
document.addEventListener('click', function (e) {
  const tooltips = document.querySelectorAll('.product-tooltip-wrapper');

  tooltips.forEach(tip => {
    if (tip.contains(e.target)) {
      tip.classList.toggle('active');
    } else {
      tip.classList.remove('active');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {

  const tooltips = document.querySelectorAll('.product-tooltip-wrapper');

  if (!tooltips) return;

  tooltips.forEach(tip => {
    tip.addEventListener('mouseenter', () => {      
        // console.log("hovered")
      tooltips.forEach(t => t.classList.remove('active'));
      tip.classList.add('active');
    });

    tip.addEventListener('mouseleave', () => {
      tip.classList.remove('active');
    });
  });


});


$(document).on('input', '.search_input_wrapper input[type="search"]', function () {
    $(this).closest('.search_input_wrapper').find('.reset__button').toggleClass('hidden', !$(this).val().trim().length);
}).on('click', '.search_input_wrapper .reset__button', function () {
    $(this).addClass('hidden');
});



// =============== MASONRY-REALIZATIONS-IMAGE-POPUP =============== 
  $(document).ready(function () {
  $('.masonry-columns').magnificPopup({
    delegate: 'a.image-popup',
    type: 'image',
    gallery: {
      enabled: true,
      tPrev: '← Previous',
      tNext: 'Next →',
      tCounter: '%curr% of %total%'
    },
    mainClass: 'mfp-fade', // smooth fade
    removalDelay: 300,
    image: {
      verticalFit: true
    }
  });
});



